import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../api/axios";

const FAQS = "/api/admin/faqs";

const root = ["faqs"];

// Envelope is the standard Ginox page: { data, currentPage, totalPages, totalRows }.
// Blank filters are dropped so "all" never reaches the backend as an empty match.
const fetchFaqList = (f) =>
  axiosInstance
    .get(FAQS, {
      params: {
        page: f.page,
        pageSize: f.pageSize,
        ...(f.search?.trim() ? { search: f.search.trim() } : {}),
        ...(f.category ? { category: f.category } : {}),
        ...(f.isActive ? { isActive: f.isActive } : {}),
      },
    })
    .then((r) => r.data.data);

export function useFaqList(filters) {
  return useQuery({
    queryKey: [...root, "list", filters],
    queryFn: () => fetchFaqList(filters),
  });
}

// [{ category, count, activeCount }]
export function useFaqCategories() {
  return useQuery({
    queryKey: [...root, "categories"],
    queryFn: () => axiosInstance.get(`${FAQS}/categories`).then((r) => r.data.data),
  });
}

// Every write can move a row in or out of a category, so both lists are dropped.
const useFaqMutation = (mutationFn) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSettled: () => queryClient.invalidateQueries({ queryKey: root }),
  });
};

// No id creates, an id edits. Both take the same body.
export const useSaveFaq = () =>
  useFaqMutation(({ id, ...body }) =>
    axiosInstance.post(id ? `${FAQS}/${id}/edit` : FAQS, body),
  );

export const useDeleteFaq = () =>
  useFaqMutation((id) => axiosInstance.post(`${FAQS}/${id}/delete`));

export const useToggleFaq = () =>
  useFaqMutation((id) => axiosInstance.post(`${FAQS}/${id}/toggle`));
